<template>
	<!-- Add New Category Form -->
	<div class="mb-5" v-if="show">
		<h3 class="font-weight-bold">Add New Category</h3>
		<form class="border mb-2">
			<div class="form-group p-3 border-bottom m-0">
					<label>Category</label>
					<!-- Category Name -->
					<input 
						type="text" 
						class="form-control" 
						v-model="inputedCategory.name"
					>
					<textarea class="form-control rounded mt-2 w-100" placeholder="description category" rows="4" v-model="inputedCategory.category_desc"></textarea>
				</div>
				<div class="form-group p-3 border-bottom m-0">
					<label class="m-0">Sub-Category</label>
					<div class="border-bottom mb-3" v-for="(subCategory, j) in inputedCategory.subs" :key="j">
						<!-- Sub Category Name -->
						<input type="text" class="form-control mt-3" v-model="subCategory.name">
				
					<!-- Topics -->
						<div class="row">
							<div class="col-md-6 pt-2" v-for="(topic, i) in subCategory.topics" :key="i">
								<input type="text" class="form-control" placeholder="Topic" v-model="subCategory.topics[i]">
							</div>
						</div>
						<button 
							class="btn bg-white text-primary font-weight-bold m-0 mt-3" 
							type="button" 
							v-on:click="addTopic(subCategory.topics)"
							>
							+ add topic
						</button>
					</div>
					<button class="btn btn-primary font-weight-bold m-0" type="button" v-on:click="addSubCategory(inputedCategory)">+ add sub-category</button>
			</div>

			<button type="button" class="btn btn-primary font-weight-bold my-3 mx-3" v-on:click="save">save</button>
			<button type="button" class="btn btn-danger font-weight-bold" v-on:click="resetForm">reset</button>
		</form>
	</div>
</template>

<script>
	import App from '@/App'
	export default {
		data: () => {
			return {
				url: App.data().url,
				show: true,
				inputedCategory: {
					name: '',
					category_desc: '',
					subs: [
						{
							name: "",
							topics: ["", ""]
						}
					]
				}
			}
		},
		mounted(){
			this.$root.$on('category-selected', () => {
				this.show = false;
			});
			this.$root.$on('category-unselected', () => {
				this.show = true;
			});
		},
		methods: {
			resetForm(){
				this.inputedCategory = {
					name: '',
					category_desc: '',
					subs: [
						{
							name: "",
							topics: ["", ""]
						}
					]
				}
			},
			save(){
				App.methods.postData(this.url.category, this.inputedCategory, () => {
				});
			},
			addSubCategory(category) {
				category.subs.push({
					name:"New Sub-Category",
					topics: ["New Topic"]
				});
			},
			addTopic(container) {
				container.push("New Topic")
			},
		}
	}
</script>